import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AppSettingsService } from '../../../../app-settings.service';


@Injectable({ providedIn: 'root' })
export class UserApiService {
  private readonly httpClient = inject(HttpClient);
  #appSettingsService = inject(AppSettingsService);

  logout(): Observable<void> {
    const loginAppBeUrl = this.#appSettingsService.appConfig?.LOGIN_APP_BE_URL?.trim();
    // Without a configured base URL the request would hit `undefined/v1/users/logout`; skip the server call and
    // let the caller run its local logout cleanup instead.
    if (!loginAppBeUrl) {
      return of(undefined);
    }

    return this.httpClient.post<void>(`${loginAppBeUrl}/v1/users/logout`, null, {
      withCredentials: true,
    });
  }
}
